// extracted by mini-css-extract-plugin
export var ecosystem = "styles-module--ecosystem--1vIwN";
export var ecosystem_bg = "styles-module--ecosystem_bg--BMjN1";
export var ecosystem_inner = "styles-module--ecosystem_inner--1idAC";
export var ecosystem_inner_l = "styles-module--ecosystem_inner_l--3UhP-";
export var ecosystem_inner_r = "styles-module--ecosystem_inner_r--2AFam";
export var ecosystem_inner_r_btn = "styles-module--ecosystem_inner_r_btn--1g_NS";
export var ecosystem_txt = "styles-module--ecosystem_txt--x63lQ";
export var ecosystem_txt_title = "styles-module--ecosystem_txt_title--BMv2Q";
export var ecosystem_txt_desc = "styles-module--ecosystem_txt_desc--3erdI";
export var ecosystem_txt_btn = "styles-module--ecosystem_txt_btn--VBmeC";
export var ecosystem_graphics = "styles-module--ecosystem_graphics--AKNnB";